module.exports = __webpack_public_path__ + "static/media/kaggle.07f29012.svg";